const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async createWarehouse({ rootState }, params = {}) {
      const data = await rootState.http("/warehouse/createWarehouse", params);
      return data;
    },
    async updateWarehouse({ rootState }, params = {}) {
      const data = await rootState.http("/warehouse/updateWarehouse", params);
      return data;
    },
    async getWarehouseList({ rootState }, params = {}) {
      const data = await rootState.http("/warehouse/queryWarehouseList", params);
      return data;
    },
    async queryWarehouseShelfList({ rootState }, params = {}) {
      const data = await rootState.http("/warehouse/shelf/page", params);
      return data;
    },
    async updateShelfEnable({ rootState }, params = {}) {
      const data = await rootState.http("/warehouse/shelf/enable", params);
      return data;
    },
    async createWarehouseShelf({ rootState }, params = {}) {
      const data = await rootState.http("/warehouse/shelf/create", params);
      return data;
    },
    async updateWarehouseShelf({ rootState }, params = {}) {
      const data = await rootState.http("/warehouse/shelf/update", params);
      return data;
    },
    async queryWarehouseShelfDetail({ rootState }, params = {}) {
      const data = await rootState.http("/warehouse/shelf/detail", params);
      return data;
    },
    async saveWarehouseShelfClass({ rootState }, params = {}) {
      const data = await rootState.http("/warehouse/shelfClass/save", params);
      return data;
    },
    async queryWarehouseShelfClass({ rootState }, params = {}) {
      const data = await rootState.http("/warehouse/shelfClass/query", params);
      return data;
    }
  }
};

export default store;
